import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { getLanguageFromHost } from '../utilities/getLanguageFromHost';

import en from './en.json';
import es from './es.json';

i18n.use(initReactI18next).init({
  interpolation: {
    escapeValue: false,
    prefix: '{',
    suffix: '}',
  },
  lng: getLanguageFromHost(),
  // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
  resources: {
    en: {
      translation: en,
    },
    es: {
      translation: es,
    },
  },
});

export default i18n;
